// Constant giới hạn của Number
export default {
  Min: 0, //Giá trị tối thiểu
  Max: 99999999999999, // Giá trị max tối đa trong grid
  MinNegative: -99999999999999, // Giá trị min tối đa trong grid
  TotalMax: 999999999999999999, // Gía trị tối đa của tổng tiền chung
  ToTalMin: -999999999999999999, // giá trị min tối đa tiền.
  MaxAmount: 100000000000000000000, // Giá trị tối đa của cột quy đổi trong chứng từ
  MinAmount: -100000000000000000000, // Giá trị tối đa của cột quy đổi trong chứng từ
  MaxCountNumber: 14,
};
